import React, { useState } from 'react';
import { t } from '../data/i18n';
import { generatePPIExcel } from '../engine/excelGenerator';
import { generatePPIPDF } from '../engine/pdfGenerator';

const emptyLine = () => ({ position: '', sousPosition: '', designation: '', stock: '', quantite: '', unite: '', observations: '' });

export default function PPIBuilder({ lang }) {
  const T = (k) => t(lang, k);
  const isAr = lang === 'ar';
  const date = new Date().toLocaleDateString('fr-FR');

  const [entreprise, setEntreprise] = useState({ raisonSociale: '', rc: '', nif: '', tel: '', email: '' });
  const [lignes, setLignes] = useState([emptyLine()]);

  const updateLine = (i, field, val) => {
    const copy = [...lignes];
    copy[i] = { ...copy[i], [field]: val };
    setLignes(copy);
  };
  const addLine = () => setLignes([...lignes, emptyLine()]);
  const removeLine = (i) => { if (lignes.length > 1) setLignes(lignes.filter((_, j) => j !== i)); };

  const handleExcel = () => generatePPIExcel({ entreprise, lignes, date }).catch(console.error);

  const handlePDF = () => generatePPIPDF({ entreprise, lignes, date });

  return (
    <div className="card" dir={isAr ? 'rtl' : 'ltr'}>
      <div className="card-title">📊 {T('section_ppi')}</div>
      <p style={{ fontSize: '0.85rem', color: 'var(--text-light)', marginBottom: '1rem' }}>{T('ppi_intro')}</p>

      {/* Entreprise info */}
      <div className="form-group">
        <label>{T('ppi_raison_sociale')} *</label>
        <input value={entreprise.raisonSociale} onChange={e => setEntreprise({ ...entreprise, raisonSociale: e.target.value })} />
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>{T('ppi_rc')} *</label>
          <input placeholder="XXXXX/XX/XXXXXXX/XX" value={entreprise.rc} onChange={e => setEntreprise({ ...entreprise, rc: e.target.value })} />
        </div>
        <div className="form-group">
          <label>{T('ppi_nif')} *</label>
          <input value={entreprise.nif} onChange={e => setEntreprise({ ...entreprise, nif: e.target.value })} />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>{T('ppi_tel')} *</label>
          <input value={entreprise.tel} onChange={e => setEntreprise({ ...entreprise, tel: e.target.value })} />
        </div>
        <div className="form-group">
          <label>{T('ppi_email')} *</label>
          <input type="email" value={entreprise.email} onChange={e => setEntreprise({ ...entreprise, email: e.target.value })} />
        </div>
      </div>

      {/* Product lines table */}
      <h4 style={{ fontSize: '0.9rem', color: 'var(--navy)', margin: '1.2rem 0 0.5rem' }}>{T('ppi_lignes')}</h4>
      <div style={{ overflowX: 'auto' }}>
        <table className="ppi-table">
          <thead>
            <tr>
              <th style={{ width: 40 }}>#</th>
              <th>{T('ppi_position')}</th>
              <th>{T('ppi_sous_position')}</th>
              <th>{T('ppi_designation')}</th>
              <th>{T('ppi_stock')}</th>
              <th>{T('ppi_quantite')}</th>
              <th>{T('ppi_unite')}</th>
              <th>{T('ppi_observations')}</th>
              <th style={{ width: 40 }}></th>
            </tr>
          </thead>
          <tbody>
            {lignes.map((l, i) => (
              <tr key={i}>
                <td style={{ textAlign: 'center', color: 'var(--text-light)' }}>{i + 1}</td>
                <td><input value={l.position} onChange={e => updateLine(i, 'position', e.target.value)} placeholder="85.44" /></td>
                <td><input value={l.sousPosition} onChange={e => updateLine(i, 'sousPosition', e.target.value)} placeholder="8544.49.90.00" /></td>
                <td><input value={l.designation} onChange={e => updateLine(i, 'designation', e.target.value)} /></td>
                <td><input value={l.stock} onChange={e => updateLine(i, 'stock', e.target.value)} /></td>
                <td><input type="number" value={l.quantite} onChange={e => updateLine(i, 'quantite', e.target.value)} /></td>
                <td><input value={l.unite} onChange={e => updateLine(i, 'unite', e.target.value)} placeholder="Kg" /></td>
                <td><input value={l.observations} onChange={e => updateLine(i, 'observations', e.target.value)} /></td>
                <td>
                  <button className="btn-delete" onClick={() => removeLine(i)} title="Supprimer" disabled={lignes.length <= 1}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem', flexWrap: 'wrap', gap: '0.5rem' }}>
        <button className="btn btn-outline" onClick={addLine} style={{ borderColor: 'var(--accent)', color: 'var(--accent)' }}>
          + {T('ppi_add_line')}
        </button>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button className="btn btn-outline" style={{ background: '#dc2626', color: 'white', borderColor: '#dc2626' }} onClick={handlePDF}>
            📄 {T('ppi_download_pdf')}
          </button>
          <button className="btn btn-outline" style={{ background: '#059669', color: 'white', borderColor: '#059669' }} onClick={handleExcel}>
            📊 {T('ppi_download_excel')}
          </button>
        </div>
      </div>
    </div>
  );
}
